import { useContext, useEffect } from 'react';

import { MapContext } from './map-ctx';
import { MarkersProps } from './map-types';
import { createLeafletMarker } from './marker';

export function Markers<DATA extends unknown>({
  markers,
  popupConfig,
}: MarkersProps<DATA>) {
  const { map } = useContext(MapContext);

  useEffect(() => {
    const mapRef = map.current;
    if (mapRef) {
      mapRef.addLeafletMarkers(markers.map(createLeafletMarker), {
        markerPopupConfig: popupConfig,
      });
      return () => {
        mapRef?.clearMarkers();
      };
    }
  }, [map, markers, popupConfig]);

  return null;
}
